import { render, staticRenderFns } from "./transfercontainer.vue?vue&type=template&id=67b261d2&scoped=true"
import script from "./transfercontainer.vue?vue&type=script&lang=js"
export * from "./transfercontainer.vue?vue&type=script&lang=js"
import style0 from "./transfercontainer.vue?vue&type=style&index=0&id=67b261d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b261d2",
  null
  
)

export default component.exports